import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";

const state = {
    insurances: [],
    insurance: null
};

const getters = {
    getAllInsurances: (state) => state.insurances,
    getSingleInsurance: (state) => state.insurance,
};

const mutations = {
    setAllInsurances(state, insurances) {
        state.insurances = insurances;
    },
    setSingleInsurance(state, insurance) {
        state.insurance = insurance;
    }
};

const actions = {
    async fetchAllInsurances({ commit }, status) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query findAllInsurances($status: InsuranceStatusEnum) {
                        findAllInsurances(status: $status) {
                            id
                            name
                            status
                        }
                    }
                `,
                variables: { status },
                fetchPolicy: 'network-only',
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            commit('setAllInsurances', response.data.findAllInsurances);
        } catch (error) {
            console.error("Failed to fetch insurances:", error);
        }
    },

    async fetchSingleInsurance({ commit }, id) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query findOneInsuranceById($id: Int!) {
                        findOneInsuranceById(id: $id) {
                            id
                            name
                            status
                        }
                    }
                `,
                variables: {
                    id: +id
                },
                fetchPolicy: 'network-only',
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            if (response.data) {
                commit('setSingleInsurance', response.data.findOneInsuranceById);
            }
        } catch (error) {
            console.error("Failed to fetch insurance:", error);
        }
    },

    async createInsurance({ commit, dispatch }, payload) {
        try {
            await apolloClient.mutate({
                mutation: gql`
                    mutation createInsurance($insuranceInput: InsuranceInput!) {
                        createInsurance(insuranceInput: $insuranceInput) {
                            id
                            name
                        }
                    }
                `,
                variables: {
                    insuranceInput: payload
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            dispatch('fetchAllInsurances');
        } catch (error) {
            console.error("Failed to create insurance:", error);
            throw error;
        }
    },

    async updateInsurance({ commit, dispatch }, { id, payload }) {
        try {
            await apolloClient.mutate({
                mutation: gql`
                    mutation updateInsurance($id: Int!, $insuranceInput: InsuranceInput!) {
                        updateInsurance(id: $id, insuranceInput: $insuranceInput) {
                            id
                            name
                        }
                    }
                `,
                variables: {
                    id: +id,
                    insuranceInput: payload
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            dispatch('fetchAllInsurances');
        } catch (error) {
            console.error("Failed to update insurance:", error);
            throw error;
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};
